
import { Component, Vue } from "vue-property-decorator";
import AuthComponent from "@/components/auth/AuthComponent.vue";

@Component({
  components: {
    AuthComponent
  },
  meta: {
    // sets document title
    title: "Auth - La Reina Digital",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Auth La Reina Digital."
      },
      keywords: { name: "keywords", content: "La Reina Digital" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class AuthView extends Vue {}
